import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';



import queryString from 'query-string';



import BaseFilter, { FilterTypeEnum } from 'components/base/BaseFilter';
import { ApprovalStatus, RECORD_FILTER_REWARD_SCOPES } from 'config/CustomEnums';


import { ArrayStringData, getHashKeyString } from 'utils';



function Filter({
  campaignList,
  earningRuleList,
  transactionList,
  backAction = () => {},
}) {
  const location = useLocation();
  const activeTab = getHashKeyString(location.hash);

  const parsedSearch = queryString.parse(location.search);
  const searchRecordScope = parsedSearch['reward_scope'] || '';
  const searchType = parsedSearch['event_type'] || '';
  const searchRecordType = parsedSearch['record_type'] || '';
  const searchPointSource = parsedSearch['point_source'] || '';
  const searchValue = parsedSearch['value'] || '';
  const searchCode = parsedSearch['gift_card_code'] || '';
  const searchCreationDate = parsedSearch['creation_date'] || '';
  const searchPurchaseDate = parsedSearch['purchase_date'] || '';
  const searchTimeRange = parsedSearch['time_range'] || '';
  const searchReportType = parsedSearch['report_type'] || '';
  const searchCampaigns = ArrayStringData(parsedSearch['campaigns'] || '');
  const searchEarningRules = ArrayStringData(
    parsedSearch['earning_rules'] || '',
  );
  const searchTransactions = ArrayStringData(parsedSearch['transaction'] || '');

  const { maxPointValue } = useSelector((state) => ({
    maxPointValue: state.pointTransactionList.maxPointValue,
  }));
  const [recordScope, setRecordScope] = useState(ArrayStringData(searchRecordScope));
  const [type, setType] = useState(searchType);
  const [recordType, setRecordType] = useState(
    ArrayStringData(searchRecordType),
  );
  const [pointSource, setPointSource] = useState(
    ArrayStringData(searchPointSource),
  );
  const [value, setValue] = useState(() => {
    const values = ArrayStringData(searchValue);
    if (values.length > 0) return values;
    return [0, 0];
  });
  const [code, setCode] = useState(searchCode);
  const [creationDate, setCreationDate] = useState(searchCreationDate);
  const [purchaseDate, setPurchaseDate] = useState(searchPurchaseDate);
  const [reportsTimeRange, setReportsTimeRange] = useState(searchTimeRange);
  const [reportType, setReportType] = useState(searchReportType);
  const [targetCampaigns, setTargetCampaigns] = useState([]);
  const [targetEarningRules, setTargetEarningRules] = useState([]);
  const [targetTransaction, setTargetTransaction] = useState([]);

  useEffect(() => {
    if (activeTab === 'Reports') {
      return;
    }
    if (searchCampaigns && campaignList) {
      let checkedCampaigns = [];
      searchCampaigns.forEach((item, index) => {
        const checkedSingeCampaign = campaignList.find(
          (value) => value?.pk === item,
        );
        if (checkedSingeCampaign) {
          checkedCampaigns.push({
            label: `[ID: ${checkedSingeCampaign?.pk}] ${checkedSingeCampaign?.name}`,
            value: checkedSingeCampaign,
          });
        }
      });
      setTargetCampaigns(checkedCampaigns);
    }
    if (searchEarningRules && earningRuleList) {
      let checkedEarningRules = [];
      searchEarningRules.forEach((item, index) => {
        const checkedSingeEarningRule = earningRuleList.find(
          (value) => value?.pk === item,
        );
        if (checkedSingeEarningRule) {
          checkedEarningRules.push({
            label: `[ID: ${checkedSingeEarningRule?.pk}] ${checkedSingeEarningRule?.name}`,
            value: checkedSingeEarningRule,
          });
        }
      });
      setTargetEarningRules(checkedEarningRules);
    }
    if (searchTransactions && transactionList) {
      let checkedTransactions = [];
      searchTransactions.forEach((item, index) => {
        const checkedSingeTransaction = transactionList.find(
          (value) => value?.pk === item,
        );
        if (checkedSingeTransaction) {
          checkedTransactions.push({
            label: `[ID: ${checkedSingeTransaction?.pk}] ${checkedSingeTransaction?.name}`,
            value: checkedSingeTransaction,
          });
        }
      });
      setTargetTransaction(checkedTransactions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  let content;
  if (activeTab === 'Reports') {
    content = [
      {
        title: 'Report type',
        data: [
          { pk: 'WEEKLY', name: 'Weekly report' },
          { pk: 'MONTHLY', name: 'Monthly report' },
        ],
        value: reportType,
        setValue: setReportType,
        component: FilterTypeEnum.singleChoice,
        className: 'fit-content-height-area',
      },
      {
        title: 'Time range',
        value: reportsTimeRange,
        setValue: setReportsTimeRange,
        component: FilterTypeEnum.dateRange,
      },
    ];
  } else {
    content = [
      {
        title: 'Reward scope',
        data: [
          {
            pk: RECORD_FILTER_REWARD_SCOPES.ALL_ISSUED,
            name: 'All issued',
          },
          {
            pk: RECORD_FILTER_REWARD_SCOPES.PARTIALLY_ISSUED,
            name: 'Partially issued',
          },
          {
            pk: RECORD_FILTER_REWARD_SCOPES.NONE_ISSUED,
            name: 'None issued',
          }
        ],
        value: recordScope,
        setValue: setRecordScope,
        component: FilterTypeEnum.choice,
        className: 'fit-content-height-area',
      },
      {
        title: 'Event Type',
        data: [
          { pk: 'TYPE_POINT_ADD', name: 'Add Points' },
          { pk: 'TYPE_POINT_REMOVE', name: 'Remove Points' },
        ],
        value: type,
        setValue: setType,
        component: FilterTypeEnum.singleChoice,
        className: 'fit-content-height-area',
      },
      {
        title: 'Point source',
        data: [
          { name: 'Loyalty', pk: 'LOYALTY' },
          { name: 'Gift card', pk: 'GIFT_CARD' },
          { name: 'Loyalty and Gift card', pk: 'LOYALTY_AND_GIFT_CARD' },
        ],
        value: pointSource,
        setValue: setPointSource,
        component: FilterTypeEnum.choice,
      },
      {
        title: 'Record type',
        data: [
          { name: 'Customer earn', pk: 'CUSTOMER_EARN' },
          {
            name: 'Customer redeem gift card',
            pk: 'CUSTOMER_REDEEM_GIFT_CARD',
          },
          { name: 'Customer use', pk: 'CUSTOMER_USED' },
          {
            name: 'Customer use cash dollar (In Online store)',
            pk: 'CUSTOMER_USED_CASH_DOLLAR',
          },
          {
            name: 'Customer use cash dollar (Merchant scan QR code)',
            pk: 'CUSTOMER_USED_CASH_DOLLAR_BY_MERCHANT_SCANNING',
          },
          {
            name: 'Merchant use cash dollar',
            pk: 'MERCHANT_USE_CASH_DOLLAR',
          },
          {
            name: 'Admin use cash dollar',
            pk: 'ADMIN_USE_CASH_DOLLAR',
          },
          { name: 'Admin edit', pk: 'ADMIN_EDITED' },
          { name: 'Merchant edit', pk: 'MERCHANT_EDITED' },
          { name: 'Auto admin edit', pk: 'AUTO_ADMIN_EDITED' },
          { name: 'Point expired', pk: 'EXPIRED' },
          { name: 'Return (Cash dollar)', pk: 'AUTO_ADMIN_EDITED_CASH_DOLLAR' },
          { name: 'Admin transferred', pk: 'ADMIN_TRANSFERRED' },
        ],
        value: recordType,
        setValue: setRecordType,
        component: FilterTypeEnum.choice,
      },
      {
        title: 'Gift card code',
        placeholder: 'Search by Gift card code',
        value: code,
        setValue: setCode,
        component: FilterTypeEnum.inputWithTitle,
      },
      {
        title: 'Purchase date',
        value: purchaseDate,
        setValue: setPurchaseDate,
        component: FilterTypeEnum.dateRange,
      },
      {
        title: 'Creation date',
        value: creationDate,
        setValue: setCreationDate,
        component: FilterTypeEnum.dateRange,
      },
      {
        title: 'Value',
        data: [0, maxPointValue],
        value: value,
        setValue: setValue,
        component: FilterTypeEnum.slider,
      },
      {
        filterTitle: 'Campaigns',
        data: campaignList,
        value: targetCampaigns,
        setValue: setTargetCampaigns,
        placeholder: 'Search by campaign ID and name',
        loadMoreAction: 'campaignList/getCampaignList',
        filterAction: 'campaignList/getCampaignList',
        customItem: (item) => `[ID: ${item?.pk}] ${item?.name}`,
        defaultFilter: {
          isSimpleList: true,
          isAvailable: false,
          noLoading: true,
          searchNameOrId: true,
          status: ApprovalStatus.published,
        },
        component: FilterTypeEnum.multipleSelectorDropdown,
      },
      {
        filterTitle: 'Earning Rules',
        data: earningRuleList,
        value: targetEarningRules,
        setValue: setTargetEarningRules,
        placeholder: 'Search by earning rule ID and name',
        loadMoreAction: 'earningRuleList/getSimpleEarningRuleListForSelector',
        filterAction: 'earningRuleList/getSimpleEarningRuleListForSelector',
        customItem: (item) => `[ID: ${item?.pk}] ${item?.name}`,
        defaultFilter: {
          isSelectorLoad: true,
        },
        component: FilterTypeEnum.multipleSelectorDropdown,
      },
      {
        filterTitle: 'Transaction',
        data: transactionList,
        value: targetTransaction,
        setValue: setTargetTransaction,
        placeholder: 'Search by transaction ID',
        loadMoreAction: 'transactions/getSimpleTransactionsForSelector',
        filterAction: 'transactions/getSimpleTransactionsForSelector',
        customItem: (item) => `[ID: ${item?.pk}] ${item?.name}`,
        component: FilterTypeEnum.multipleSelectorDropdown,
      },
    ];
  }

  return <BaseFilter content={content} backAction={backAction} />;
}

const mapPropsToState = (state) => ({
  campaignList: state.campaignList.allList,
  earningRuleList: state.earningRuleList.earningRuleList,
  transactionList: state.transactions.transactionList,
});

export default connect(mapPropsToState)(Filter);